import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Single from '../Assets/Single.jpg'


function Individual() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Card>
                <Card.Img variant="top" src={Single} />
                <Card.Body>
                    <Card.Title>Individual</Card.Title>
                    <Card.Text>
                        You're a boundless being with heavy loads of works, such loads can burden you ,  we can lighten your load.
                    </Card.Text>
                    <Button style={{backgroundColor:"#6883BC",borderRadius: "0",border: "none"}} onClick={handleShow}>Know More</Button>
                </Card.Body>
            </Card>
            <Offcanvas show={show} onHide={handleClose} style={{ width: "-webkit-fill-available" }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>INDIVIDUAL THERAPY</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <p><b>Anxiety</b></p>
                    <p>Anxiety disorder involves excessive fear or worry of people/situation/event/object or place. It
                        can also happen due to a traumatic incident such as natural disaster, accidents,etc .
                        Psychological and emotional concerns affect one’s sleep, diet and social involvement too.</p>
                    <p><b>Symptoms</b></p>
                    <ul><li>
                        Psychological symptoms- overthinking, negative thoughts, trouble listening , self
                        occupied
                    </li>
                        <li>Physical symptoms such as Trembling or shaking, Restlessness,Shortness of breath,
                            cold sweat, pale face, dry mouth, inconsistent speech, stomach sickness</li></ul>
                    <p><b>Types of Anxiety Disorder</b></p>
                    <ul><li><b>Generalized anxiety disorder : </b>
                        Sometimes there is no specific cause for a person to worry about things in their life.
                        This then tends to impact their emotional and physical wellbeing. A more general and
                        scattered nature of anxiety is what leads to the diagnosis of Generalized Anxiety
                        Disorder.</li>
                        <li><b>Phobias : </b>
                            Phobias can be defined as irrational, debilitating and excessive fear for an object,
                            animal, situation or place. These are more severe than fears where the danger is often
                            perceived as unrealistically threatening.</li>
                        <li><b>Panic Disorder : </b>
                            It is an intense fear or discomfort that reaches a peak within 10 minutes or less and then
                            begins to subside.</li>
                        <li><b>Social Anxiety : </b>
                            It is characterized by fear of social interactions and situations. A person has a fear of
                            being judged, embarrassed, humiliated or offending someone. This inhibits them from
                            attending important social events and could also make them withdrawn and isolated.
                            This type of anxiety holds people back in many ways for achieving and doing things
                            that they want to do.</li>
                        <li><b>Separation Anxiety : </b>
                            It is an excessive fear of losing or getting harmed by the major attachment figure and it
                            interferes with or limits an adult’s daily life functioning in a variety of ways.</li>

                        <li><b>Retroactive jealousy : </b>
                            It involves obsessive thoughts about partner’s past sexual encounters. Retroactive
                            jealousy could lead to making a pleasant relationship turn sour resulting in divorce or
                            breakups</li>
                        <li><b>Obsessive Compulsive Disorder : </b>
                            In OCD people exhibit compulsive behavior in particular to deal with anxiety provoking
                            situations. OCD comes in various themes- checking, repeating, cleanliness, organizing
                            and obsessive thoughts.</li>
                        <li><b>Substance induced Anxiety : </b>
                            Overuse or mix of different substances also leads to increased anxiety, palpitations and
                            other symptoms.
                        </li></ul>
                    <p><b>Depression</b></p>
                    <p>Depression is a word that is widely used but less understood. It is often confused with sadness,
                        anxiety, phobia or stress.Depression can be more than a constant state of sadness or feeling
                        “blue.”</p>
                    <p>Depression can cause a variety of symptoms. Some affect your mood and others affect your
                        body. Symptoms may also be ongoing or come and go.</p>
                    <p><b>Symptoms</b></p>
                    <p>Not everyone with depression will experience the same symptoms. Symptoms can vary in
                        severity, how often they happen, and how long they last.</p>

                    <p>If you experience some of the following signs feeling sad, anxious, or “empty”</p>
                    <ul><li>Feeling hopeless, worthless, and pessimistic</li>
                        <li>Crying a lot</li>
                        <li>Feeling bothered, annoyed, or angry</li>
                        <li>Loss of interest in hobbies and interests you once enjoyed</li>
                        <li>Decreased energy or fatigue</li>
                        <li>Difficulty concentrating, remembering, or making decisions</li>
                        <li>Moving or talking more slowly</li>
                        <li>Difficulty sleeping, early morning awakening, or oversleeping</li>
                        <li>Appetite or weight changes</li>
                        <li>Chronic physical pain with no clear cause that does not get better with treatment 
                            (headaches, aches or pains, digestive problems, cramps)</li>
                        <li>Thoughts of death, suicide, self-harm, or suicide attempts
                        </li></ul>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Individual;